import { get } from "../utility/fetch-util";


/**
 *  Get quotes for driver
 */
export const getQuotes = async (entityId, type, customerCode, progress) => {
    return get('/api/drivers/quotations/customer/entity/' + entityId + '/type/' + type + '/code/' + customerCode, null, progress);
}